const HPUpdatableNotifications = [
    20,
];

export default HPUpdatableNotifications;



// WEBPACK FOOTER //
// ./src/app/config/constants/NotificationUpdateableTypes.constant.js